import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-b74bf866"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-item-container" }
const _hoisted_2 = { class: "questions-container" }
const _hoisted_3 = { class: "question-primary-language" }
const _hoisted_4 = {
  key: 0,
  class: "question-secondary-language"
}
const _hoisted_5 = { class: "response-container" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 5,
  class: "rating-caption ion-padding-top"
}
const _hoisted_13 = {
  key: 6,
  class: "rating-caption ion-padding-top"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.question_lang1), 1),
      (_ctx.bilingue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.question_lang2), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maxStars, (star) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "cursor-pointer",
          key: star,
          onClick: ($event: any) => (_ctx.handleClick(star))
        }, [
          (star === 1)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: star !== _ctx.currentRating ? _ctx.star1Icon : _ctx.star1FilledIcon
              }, null, 8, _hoisted_7))
            : _createCommentVNode("", true),
          (star === 2)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: star !== _ctx.currentRating ? _ctx.star2Icon : _ctx.star2FilledIcon
              }, null, 8, _hoisted_8))
            : _createCommentVNode("", true),
          (star === 3)
            ? (_openBlock(), _createElementBlock("img", {
                key: 2,
                src: star !== _ctx.currentRating ? _ctx.star3Icon : _ctx.star3FilledIcon
              }, null, 8, _hoisted_9))
            : _createCommentVNode("", true),
          (star === 4)
            ? (_openBlock(), _createElementBlock("img", {
                key: 3,
                src: star !== _ctx.currentRating ? _ctx.star4Icon : _ctx.star4FilledIcon
              }, null, 8, _hoisted_10))
            : _createCommentVNode("", true),
          (star === 5)
            ? (_openBlock(), _createElementBlock("img", {
                key: 4,
                src: star !== _ctx.currentRating ? _ctx.star5Icon : _ctx.star5FilledIcon
              }, null, 8, _hoisted_11))
            : _createCommentVNode("", true),
          (_ctx.getCurrentRating === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.getDefaultStarLabel(star)), 1))
            : (_ctx.getCurrentRating === star)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.getStarLabel(star)), 1))
              : _createCommentVNode("", true)
        ], 8, _hoisted_6))
      }), 128))
    ])
  ]))
}